export function hexToRgba(hex, alpha = 1) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function sportStyles(color) {
  return {
    cardSelected:  { background: `linear-gradient(135deg, ${color}, ${color}cc)`, borderColor: color },
    cardDefault:   { backgroundColor: hexToRgba(color, 0.07), borderColor: hexToRgba(color, 0.25) },
    banner:        { background: `linear-gradient(135deg, ${color}ee, ${color}99)` },
    badge:         { backgroundColor: hexToRgba(color, 0.15), color },
    bullet:        { backgroundColor: color },
    text:          { color },
    border:        { borderColor: hexToRgba(color, 0.3) },
    numberBadge:   { backgroundColor: color, color: '#fff' },
  };
}
